// The three YourReGen goals — the only goals offered anywhere in the app.
export const GOALS = ['Lose Fat', 'Build Muscle', 'Strength & Longevity'];

export const isGoal = (g) => GOALS.includes(g);
